import React from "react";
import Carousel from "./Carousel";

const Features = () => {
  return (
    <div className="features">
      <div className="features__header">
        <div className="features__header--heading">
          Building Products which make you Future Ready
        </div>
        <div className="features__header--content">
          Our mission is to bring each utility needed by you to grow bigger and
          faster, on one single platform.
        </div>
      </div>
      <div className="features__content">
        <Carousel />
      </div>
    </div>
  );
};

export default Features;
